'use strict';
const createSuccessNotification = require('friartux/components/successNotification');
var createErrorNotification = require('friartux/components/errorNotification');
const { handleCustomLookNameInit } = require('friartux/components/handleCustomLookName');

const SELECTORS = {
    body: 'body',
    replaceCartModal: '.js-replace-cart-items-modal',
    addToCartContainer: '.js-add-to-cart-container',
    clearCartBtn: '.js-clear-cart-btn',
    saveCartAsLookBtn: '.js-custom-look-name-btn',
    addToCart: '.add-to-cart',
    customLookNameInput: '.js-custom-look-name',
    miniCartQty: '.minicart .minicart-quantity',
    miniCartLink: '.minicart .minicart-link',
    generalErrorContainer: '.error-messaging',
    successMessageContainer: '.success-messaging',
    purchaseOptionContainer: '.ecom-buttons-container > .active',
    activeAddToCart: '.ecom-buttons-container .active .js-add-to-cart-modal, .ecom-buttons-container .active .add-to-cart'
};

const handleClearCartAndContinue = (e) => {
    e.preventDefault();

    $.spinner().start();
    $.ajax({
        url: Urls.cartRemoveAllUrl,
        type: 'GET',
        dataType: 'json',
        success: (response) => {
            $('body').trigger('cart:update');
            let $addToCartBtn = $(SELECTORS.activeAddToCart);
            $addToCartBtn.trigger('click');

            let $replaceCartModal = $(SELECTORS.replaceCartModal);
            $replaceCartModal.modal('hide');

            $.spinner().stop();

            if (response.error) {
                createErrorNotification($(SELECTORS.generalErrorContainer), response.errorMessage);
            }
        }
    });
}

const handleSaveCartAsLook = (e) => {
    const $btn = $(e.currentTarget);
    e.preventDefault();
    const saveLookModal = $($btn.data('target'));
    $(SELECTORS.replaceCartModal).html(saveLookModal.html());
}

const handleReplaceCartModal = () => {
    $(SELECTORS.replaceCartModal).modal('dispose');
    $(SELECTORS.replaceCartModal);
}

const handleSaveCustomLook = () => {
    $(SELECTORS.body).on('customLook:save', (event, data) => {
        if (data.error && data.redirectUrl) {
            window.location = data.redirectUrl;
        }

        if (data.successMsg) {
            createSuccessNotification($(SELECTORS.successMessageContainer), data.successMsg, 5000, true);
        }

        // Update mini cart
        $(SELECTORS.miniCartQty).text(data.quantityTotal);
        $(SELECTORS.miniCartLink).attr({
            'aria-label': data.minicartCountOfItems,
            title: data.minicartCountOfItems
        });

        // Add the product to cart.
        setTimeout(() => {
            $(SELECTORS.purchaseOptionContainer).find(SELECTORS.addToCart).trigger('click');
        }, 3000);

        $(SELECTORS.replaceCartModal).modal('hide');
    });
}

const handleCartActions = () => {
    $(SELECTORS.body).on('click', SELECTORS.clearCartBtn, handleClearCartAndContinue);
    $(SELECTORS.body).on('click', SELECTORS.saveCartAsLookBtn, handleSaveCartAsLook);
    $(SELECTORS.body).on('hidden.bs.modal', SELECTORS.replaceCartModal, handleReplaceCartModal);
    handleCustomLookNameInit();
    handleSaveCustomLook();
};

module.exports = {
    handleCartActions
};
